export default "__VITE_ASSET__DlHnbtNI__"